import React from "react";
import SubmitButton from "./styled/SubmitButton";
import AnimatedDots from "./AnimatedDots";

const FormSubmitButton = ({ loader }) => {
  return (
    <SubmitButton
      type="submit"
      style={{ background: loader ? "#ccc" : "#216ba5" }}
      disabled={loader}
    >
      {loader ? <AnimatedDots /> : "Registrarse"}
    </SubmitButton>
  );
};

export default FormSubmitButton;
